import {
  Button,
  Grid,
  Card,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  Input,
  FormHelperText,
  Chip,
  Paper,
  Typography,
  Box,
  TextField
} from '@material-ui/core';
import * as Yup from 'yup';
import React, { useState } from 'react';
import Select from 'react-select/creatable';
import { FormikProvider, Form } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.error.main
  },
  bgRed: {
    backgroundColor: theme.palette.background.paper
  },
  chipContainer: {
    padding: theme.spacing(2),
    overflow: 'hidden auto'
    // height: '200px'
  },
  radiocolor: {
    color: '#003458'
  },
  paper: {
    padding: '40px'
  },
  chip2: {
    border: 'none',
    margin: '5px',
    // color: '#1786D0',
    borderRadius: '4px',
    background: '#F1F4F8'
  }
}));

const customStylesSelect = {
  control: (provided) => ({
    border: 'none',
    width: '100%',
    color: '#003458',
    borderBottom: '1px solid #21C8AA'
  }),
  indicatorsContainer: (provided) => ({
    display: 'none'
  }),
  option: (provided) => ({
    ...provided,
    color: '#000'
  })
};

export default function Skills({ formik }) {
  const classes = useStyles();
  const [value, setValue] = useState(null);
  const { values, setFieldValue } = formik;
  const [chips, updatedchips] = useState('');
  const top5Skills = formik.values.skills.slice(0, 5);
  const otherSkills = formik.values.skills.slice(5, values.skills.length);
  const handleDelete = (chipToDelete) => {
    console.log('chip to set data', chipToDelete);
    const deleteChip = values.skills.filter(
      (chip) => chip.value !== chipToDelete.value
    );
    setFieldValue('skills', deleteChip);
  };

  const handleAddSkill = (value) => {
    let addNewData = values.skills;
    addNewData = [
      ...values.skills,
      {
        value: value,
        label: value,
        key: Math.round(Math.random() * 200)
      }
    ];
    console.log('handdle skillss data', value, addNewData);
    setFieldValue('skills', addNewData);
    setValue(null);
  };

  function handleOnDragEnd(result) {
    const { source, destination, draggableId } = result;
    console.log(result);
    if (!destination) return;
    if (destination.droppableId === source.droppableId) return;
    if (destination.droppableId === 'top5skills') {
      let lastIndex = top5Skills.length - 1;
      otherSkills.push(top5Skills[lastIndex]);
      console.log('lent', top5Skills.length, top5Skills);
      if (top5Skills.length >= 5) {
        top5Skills.pop();
      }
      top5Skills.push(otherSkills.find((elem) => elem.key === source.index));
      console.log(
        'index',
        otherSkills.findIndex((elem) => elem.key === source.index),
        otherSkills
      );
      otherSkills.splice(
        otherSkills.findIndex((elem) => elem.key === source.index),
        1
      );

      setFieldValue('skills', [...top5Skills, ...otherSkills]);

      console.log(values.skills);
    }
  }

  // console.log('formik data', formik.values);
  return (
    // <Paper className={classes.paper}>
    <FormikProvider value={formik}>
      <Form noValidate>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Grid container spacing={3}>
            {/* <Grid container> */}
            {/* <FormLabel id="demo-mutiple-chip-label">Skillszzzz</FormLabel> */}
            <Grid item xs={12} style={{ lineHeight: 1 }}>
              {/* <Select
                styles={customStylesSelect}
                options={formik.skills}
                value={value}
                isClearable
                onChange={(selectedOptions) => setValue(selectedOptions)}
                onCreateOption={handleAddSkill}
                mt={5}
              /> */}
              <br />
              <Typography color="primary" variant="body2">
                Hard skills are technical knowledge or training that you have
                gained through any life experience, including in your career or
                education
                <span style={{ opacity: '0.5' }}>
                  {' '}
                  (Ex: Database Management, Programming Languages, etc )
                </span>
              </Typography>
            </Grid>
            <Grid item sm={6}>
              <Select
                fullWidth
                placeholder="Type your hard skills here..."
                styles={customStylesSelect}
                options={formik.skills}
                value={value}
                isClearable
                onChange={(selectedOptions) => setValue(selectedOptions)}
                onCreateOption={handleAddSkill}
              />
              {/* <Input
                style={{
                  width: '100%',
                  color: '#003458',
                  borderBottom: '1px solid #21C8AA'
                }}
                id="standard-adornment-amount"
                color="secondary"
                placeholder="| Type your hard skills here..."
                inputComponent={() => (
                  <Select
                    fullWidth
                    styles={customStylesSelect}
                    options={formik.skills}
                    value={value}
                    isClearable
                    onChange={(selectedOptions) => setValue(selectedOptions)}
                    onCreateOption={handleAddSkill}
                  />
                )}
              /> */}
              <br />
              <br />
              <label style={{ color: 'grey' }}>
                <i>Top 5 Hard Skills</i>
              </label>

              <Box
                mt={3}
                style={{
                  border: '1px dashed rgba(0, 0, 0, 0.5)',
                  marginTop: '5px'
                }}
              >
                <Grid item xs={12} className={classes.chipContainer}>
                  <Droppable droppableId="top5skills">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {top5Skills.map((skill) => (
                          <Draggable
                            draggableId={skill.value}
                            key={skill.value}
                            index={skill.key}
                          >
                            {(provided) => (
                              <Chip
                                className={classes.chip2}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                                color="primary"
                                label={<Typography> {skill.value}</Typography>}
                                onDelete={() => handleDelete(skill)}
                                onDragStart={() =>
                                  console.log('dragginnnnnngg')
                                }
                                allowDragAndDrop="true"
                                scope="combined-chip"
                                style={{
                                  background: '#F1F4F8',
                                  color: '#003458 ',
                                  margin: '5px'
                                }}
                                // deleteIcon={
                                //   <HighlightOffIcon
                                //     onClick={() => handleDelete(skill)}
                                //   />
                                // }
                              />
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                  {/* </DragDropContext> */}
                </Grid>
              </Box>
              <br />
              <label style={{ color: 'grey' }}>
                <i>Other Hard Skills</i>
              </label>
              <Box
                mt={3}
                style={{ border: '1px solid #D9DBDD', marginTop: '5px' }}
              >
                <Grid
                  item
                  xs={12}
                  className={classes.chipContainer}
                  style={{ height: '200px' }}
                >
                  <Droppable droppableId="otherSkills">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {otherSkills.map((skill, id, index, key) => (
                          <Draggable
                            draggableId={skill.value}
                            key={skill.value}
                            index={skill.key}
                          >
                            {(provided) => (
                              <Chip
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                                color="primary"
                                variant="outlined"
                                label={<Typography> {skill.value}</Typography>}
                                onDelete={() => handleDelete(skill)}
                                className={classes.chip2}
                                // deleteIcon={
                                //   <HighlightOffIcon
                                //     onClick={() => handleDelete(skill)}
                                //   />
                                // }
                              />
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </Grid>
              </Box>
            </Grid>
            <Grid item sm={6}>
              <Typography
                color="primary"
                style={{ paddingTop: '15%', paddingLeft: '5%' }}
              >
                Note{' '}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4375 10.5C14.4381 9.80872 14.2568 9.1294 13.9116 8.5304C13.5664 7.9314 13.0696 7.43384 12.4712 7.08775C11.8727 6.74167 11.1937 6.55925 10.5023 6.55884C9.81099 6.55843 9.13173 6.74005 8.53286 7.08544C7.93398 7.43082 7.4366 7.92779 7.09072 8.52638C6.74484 9.12497 6.56266 9.80408 6.5625 10.4954C6.56234 11.1867 6.7442 11.8659 7.08979 12.4647C7.43539 13.0634 7.93254 13.5606 8.53125 13.9063V15.0938H12.4687V13.9063C13.0671 13.5614 13.5641 13.0651 13.9097 12.4671C14.2554 11.8691 14.4374 11.1907 14.4375 10.5Z"
                    fill="#F9C74F"
                  />
                  <path
                    d="M11.8125 11.8125C12.1749 11.8125 12.4688 11.5187 12.4688 11.1562C12.4688 10.7938 12.1749 10.5 11.8125 10.5C11.4501 10.5 11.1562 10.7938 11.1562 11.1562C11.1562 11.5187 11.4501 11.8125 11.8125 11.8125Z"
                    fill="#7CCDF4"
                  />
                  <path
                    d="M9.1875 11.8125C9.54994 11.8125 9.84375 11.5187 9.84375 11.1562C9.84375 10.7938 9.54994 10.5 9.1875 10.5C8.82506 10.5 8.53125 10.7938 8.53125 11.1562C8.53125 11.5187 8.82506 11.8125 9.1875 11.8125Z"
                    fill="#7CCDF4"
                  />
                  <path
                    d="M11.8125 15.0938H9.1875V16.4062H11.8125V15.0938Z"
                    fill="#9B9C9B"
                  />
                  <path
                    d="M8.53125 16.4062H12.4688V17.7188C12.4688 17.8928 12.3996 18.0597 12.2765 18.1828C12.1535 18.3059 11.9865 18.375 11.8125 18.375H9.1875C9.01345 18.375 8.84653 18.3059 8.72346 18.1828C8.60039 18.0597 8.53125 17.8928 8.53125 17.7188V16.4062Z"
                    fill="#4F5D75"
                  />
                  <path
                    d="M9.51562 18.375H11.4844V19.6875C11.4844 19.8615 11.4152 20.0285 11.2922 20.1515C11.1691 20.2746 11.0022 20.3438 10.8281 20.3438H10.1719C9.99783 20.3438 9.83091 20.2746 9.70784 20.1515C9.58477 20.0285 9.51562 19.8615 9.51562 19.6875V18.375Z"
                    fill="#242423"
                  />
                  <path
                    d="M11.4841 15.0938H10.8279V12.1407H10.1716V15.0938H9.51538V12.1407H9.24697C9.11292 12.1484 8.9787 12.1287 8.85254 12.0827C8.72638 12.0368 8.61094 11.9655 8.5133 11.8733C8.41565 11.7812 8.33786 11.67 8.28469 11.5467C8.23153 11.4234 8.2041 11.2906 8.2041 11.1563C8.2041 11.022 8.23153 10.8892 8.28469 10.7659C8.33786 10.6426 8.41565 10.5314 8.5133 10.4393C8.61094 10.3471 8.72638 10.2758 8.85254 10.2299C8.9787 10.1839 9.11292 10.1642 9.24697 10.1719C9.37403 10.1701 9.50007 10.1949 9.61704 10.2445C9.73402 10.2941 9.83937 10.3676 9.92637 10.4602C10.0134 10.5528 10.0801 10.6626 10.1223 10.7824C10.1646 10.9023 10.1814 11.0296 10.1716 11.1563V11.4844H10.8279V11.1563C10.8182 11.0296 10.8349 10.9023 10.8772 10.7824C10.9194 10.6626 10.9861 10.5528 11.0731 10.4602C11.1601 10.3676 11.2655 10.2941 11.3825 10.2445C11.4994 10.1949 11.6255 10.1701 11.7525 10.1719C11.8866 10.1642 12.0208 10.1839 12.147 10.2299C12.2731 10.2758 12.3886 10.3471 12.4862 10.4393C12.5839 10.5314 12.6616 10.6426 12.7148 10.7659C12.768 10.8892 12.7954 11.022 12.7954 11.1563C12.7954 11.2906 12.768 11.4234 12.7148 11.5467C12.6616 11.67 12.5839 11.7812 12.4862 11.8733C12.3886 11.9655 12.2731 12.0368 12.147 12.0827C12.0208 12.1287 11.8866 12.1484 11.7525 12.1407H11.4841V15.0938ZM11.4841 11.4844H11.7525C11.8002 11.4924 11.8491 11.49 11.8957 11.4772C11.9423 11.4643 11.9856 11.4415 12.0225 11.4103C12.0595 11.3791 12.0891 11.3402 12.1095 11.2963C12.1298 11.2524 12.1403 11.2047 12.1403 11.1563C12.1403 11.1079 12.1298 11.0602 12.1095 11.0163C12.0891 10.9724 12.0595 10.9335 12.0225 10.9023C11.9856 10.8711 11.9423 10.8483 11.8957 10.8355C11.8491 10.8227 11.8002 10.8202 11.7525 10.8282C11.5744 10.8282 11.4841 10.9384 11.4841 11.1563V11.4844ZM9.24697 10.8282C9.19928 10.8202 9.15042 10.8227 9.10379 10.8355C9.05716 10.8483 9.01388 10.8711 8.97697 10.9023C8.94005 10.9335 8.91039 10.9724 8.89004 11.0163C8.8697 11.0602 8.85916 11.1079 8.85916 11.1563C8.85916 11.2047 8.8697 11.2524 8.89004 11.2963C8.91039 11.3402 8.94005 11.3791 8.97697 11.4103C9.01388 11.4415 9.05716 11.4643 9.10379 11.4772C9.15042 11.49 9.19928 11.4924 9.24697 11.4844H9.51538V11.1563C9.51538 10.9384 9.42514 10.8282 9.24697 10.8282Z"
                    fill="#C5C6C6"
                  />
                  <path
                    d="M10.8281 0.984375C10.8281 0.803157 10.6812 0.65625 10.5 0.65625C10.3188 0.65625 10.1719 0.803157 10.1719 0.984375V4.26562C10.1719 4.44684 10.3188 4.59375 10.5 4.59375C10.6812 4.59375 10.8281 4.44684 10.8281 4.26562V0.984375Z"
                    fill="#E9FF70"
                  />
                  <path
                    d="M20.0156 10.5H16.7344C16.5532 10.5 16.4062 10.6469 16.4062 10.8281C16.4062 11.0093 16.5532 11.1562 16.7344 11.1562H20.0156C20.1968 11.1562 20.3438 11.0093 20.3438 10.8281C20.3438 10.6469 20.1968 10.5 20.0156 10.5Z"
                    fill="#E9FF70"
                  />
                  <path
                    d="M4.26562 10.5H0.984375C0.803157 10.5 0.65625 10.6469 0.65625 10.8281C0.65625 11.0093 0.803157 11.1562 0.984375 11.1562H4.26562C4.44684 11.1562 4.59375 11.0093 4.59375 10.8281C4.59375 10.6469 4.44684 10.5 4.26562 10.5Z"
                    fill="#E9FF70"
                  />
                  <path
                    d="M18.3886 3.96671L16.0684 6.2869C15.9403 6.41504 15.9403 6.6228 16.0684 6.75094C16.1966 6.87908 16.4043 6.87908 16.5325 6.75094L18.8527 4.43075C18.9808 4.3026 18.9808 4.09485 18.8527 3.96671C18.7245 3.83857 18.5168 3.83857 18.3886 3.96671Z"
                    fill="#E9FF70"
                  />
                  <path
                    d="M4.46725 14.6064L2.14706 16.9266C2.01892 17.0547 2.01892 17.2624 2.14706 17.3906C2.2752 17.5187 2.48296 17.5187 2.6111 17.3906L4.93129 15.0704C5.05943 14.9423 5.05943 14.7345 4.93129 14.6064C4.80315 14.4782 4.59539 14.4782 4.46725 14.6064Z"
                    fill="#E9FF70"
                  />
                  <path
                    d="M16.5325 14.6062C16.4043 14.4781 16.1966 14.4781 16.0684 14.6062C15.9403 14.7344 15.9403 14.9421 16.0684 15.0703L18.3886 17.3905C18.5168 17.5186 18.7245 17.5186 18.8527 17.3905C18.9808 17.2623 18.9808 17.0546 18.8527 16.9264L16.5325 14.6062Z"
                    fill="#E9FF70"
                  />
                  <path
                    d="M2.61159 3.96634C2.48344 3.8382 2.27569 3.8382 2.14755 3.96634C2.01941 4.09449 2.01941 4.30224 2.14755 4.43038L4.46774 6.75058C4.59588 6.87872 4.80364 6.87872 4.93178 6.75058C5.05992 6.62244 5.05992 6.41468 4.93178 6.28654L2.61159 3.96634Z"
                    fill="#E9FF70"
                  />
                </svg>
                <ul>
                  <li>
                    If you are unable to find a skill, create one manually by
                    pressing <strong>‘Enter’ or ‘Done’.</strong>
                  </li>
                  <li>
                    {' '}
                    You can select <strong>only 5 top skills</strong>
                  </li>
                  <li>
                    <strong>Drag and drop</strong> to move skills to top{' '}
                  </li>
                </ul>
              </Typography>
            </Grid>
          </Grid>
        </DragDropContext>
      </Form>
    </FormikProvider>
    // </Paper>
  );
}
